import MoreChallengesRouteContainer from "@features/challenges/containers/MoreChallengesRouteContainer";

const MoreChallengesRoute = () => {
	return <MoreChallengesRouteContainer />;
};

export default MoreChallengesRoute;
